import jwt from '../../http/requests/auth/jwt/index.js';
import router from '@/router';
import axios from '@/axios.js';

export default {
  loginAttempt({ dispatch }, payload) {
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation,
    };

    dispatch('login', newPayload);
  },
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.displayName,
      })
      .then(() => {
        // update in localstorage
        const newUserData = Object.assign({}, payload.user.providerData[0]);
        newUserData.displayName = payload.displayName;
        commit('UPDATE_USER_INFO', newUserData, { root: true });

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || '/');
        }
      })
      .catch(err => {
        payload.notify({
          time: 8800,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
  },
  login({ commit }, payload) {
    commit('LOGIN_LOADING');

    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.username, payload.userDetails.password)
        .then(async response => {
          // If there's user data in response
          if (response.data) {
            // Set accessToken & tokenExpiry & LoggedIn
            localStorage.setItem('accessToken', response.data.access_token);
            localStorage.setItem('tokenExpiry', Date.now() + response.data.expires_in);
            localStorage.setItem('loggedIn', true);

            var base64Url = response.data.access_token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(
              atob(base64)
                .split('')
                .map(function(c) {
                  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
            );
            let userInfo = JSON.parse(jsonPayload);
            // Set bearer token in axios
            commit('SET_BEARER', response.data.access_token);

            // Update user details
            commit('UPDATE_USER_INFO', userInfo, { root: true });

            await axios
              .get('/admins/current')
              .then(currentUserResponse => {
                if (currentUserResponse.data.profilePicture) {
                  currentUserResponse.data.photoURL = currentUserResponse.data.profilePicture;
                }
                commit('UPDATE_USER_INFO', currentUserResponse.data, { root: true });
              })
              .catch(error => {
                reject(error);
              });

            await axios
              .get('/admins/permissions')
              .then(response => {
                if(response.data) {
                  commit("UPDATE_USER_PERMISSIONS", response.data, { root: true });
                }
              })
              .catch(error => {
                reject(error);
              });

            resolve(response);
          } else {
            localStorage.removeItem('permissions');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('tokenExpiry');
            localStorage.removeItem('loggedIn');
            reject({ message: 'Wrong Email or Password' });
          }
        })
        .then(() => {
          commit('LOGIN_SUCCESS');
          router.push(router.currentRoute.query.to || '/').catch(() => {});
        })
        .catch(error => {
          commit('LOGIN_ERROR', error);
          reject(error);
        });
    });
  },
  fetchAccessToken() {
    return new Promise(resolve => {
      jwt.refreshToken().then(response => {
        resolve(response);
      });
    });
  },
};
